import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBagShopping, faCheck } from "@fortawesome/free-solid-svg-icons";
import { ajoutChariot, saveVariableGlo } from "../actions/chariotActions";
import "../ListeArticles.css";

const ListeArticles = ({ article, client, langue, source, wcli }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const uri = "https://gestpro.globalsystempro.com";
  const sour = article.image ? `${uri}${article.image}` : null;

  const [qty, setQty] = useState(1);
  const [unite, setUnite] = useState("E");
  const chariotListe = useSelector((state) => state.chariot.chariotListe);
  const varGlo = useSelector((state) => state.chariot.varGlo);
  const socActuelle = useSelector((state) => state.societeActuelle.socActuelle);

  const testPanExist = (id) => {
    return chariotListe?.some((ch) => ch.article == id);
  };

  const prixUnitaire = (cod_tarif) => {
    switch (cod_tarif) {
      case "G1":
        return article?.prix_1;
      case "G2":
        return article?.prix_2;
      case "G3":
        return article?.prix_3;
      default:
        return article?.prix_1;
    }
  };

  const panierHandler = () => {
    const prix =
      unite == "E"
        ? prixUnitaire(wcli?.cod_tarif)
        : prixUnitaire(wcli?.cod_tarif) / article.coiff;

    dispatch(
      ajoutChariot(
        article._id,
        qty,
        prix * qty,
        langue,
        source,
        prix,
        unite,
        article.code_art
      )
    );
  };

  const calculateTotal = () => {
    const unitPrice =
      unite == "E"
        ? prixUnitaire(wcli?.cod_tarif)
        : prixUnitaire(wcli?.cod_tarif) / article.coiff;
    return (unitPrice * qty).toFixed(3);
  };

  const isDisabled = !article.partager && client?.nivcli_cloud == "F";

  const handleAddToCart = () => {
    if (!varGlo || Object.keys(varGlo).length === 0) {
      navigate(client.nivcli_cloud == "R" ? "/dem-repres" : "/DemAdmin", {
        state: {
          client: client.nom_cli,
          langue: langue,
          societe: socActuelle?.nom_soc,
        },
      });
    } else {
      panierHandler();
    }
  };

  return (
    <div className="article-card">
      {/* Title Row */}
      <div className="title-row">
        <h3 className="title-text">
          {langue == "A" && article?.lib_ar ? article.lib_ar : article.nom}
        </h3>
        {testPanExist(article._id) && (
          <div className="check-icon-container">
            <FontAwesomeIcon icon={faCheck} className="check-icon" />
          </div>
        )}
      </div>

      {/* Image */}
      {sour && (
        <div className="image-container">
          <img
            src={sour}
            alt={article.nom}
            className="article-image"
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />
        </div>
      )}

      {/* Price Info */}
      <div className="price-container">
        <div className="price-text-container">
          <p className="price-text">
            {langue == "F" ? "PUV" : "السعر الفردي"}:{" "}
            {(unite == "E"
              ? prixUnitaire(wcli?.cod_tarif)
              : prixUnitaire(wcli?.cod_tarif) / article.coiff
            ).toFixed(3)}
          </p>
          <p className="price-text">
            {langue == "A" ? "المجموع" : "Total"}: {calculateTotal()}
          </p>
        </div>

        {article.coiff >= 1 && (
          <button
            className="unit-toggle"
            onClick={() => setUnite(unite == "E" ? "V" : "E")}
          >
            <span className="unit-text">Piece: {article.coiff || 1}</span>
            <span className="unit-type-text">
              {unite == "E" ? "Emb" : "Vrac"}
            </span>
          </button>
        )}
      </div>

      {/* Quantity Controls */}
      <div className="quantity-container">
        <button
          className={`quantity-button ${isDisabled ? "disabled" : ""}`}
          onClick={() => {
            if (article.art_max == "O" && qty >= article.nbr_max) {
              alert(
                langue == "F"
                  ? "Quantité maximale atteinte"
                  : "لقد تخطيت الكمية المسموح بها"
              );
            } else {
              setQty(qty + 1);
            }
          }}
          disabled={isDisabled}
        >
          <span className="quantity-button-text">+</span>
        </button>

        <div className="quantity-display">
          <span className="quantity-text">{qty}</span>
        </div>

        <button
          className={`quantity-button ${qty === 1 ? "disabled" : ""}`}
          onClick={() => setQty(Math.max(1, qty - 1))}
          disabled={qty === 1}
        >
          <span className="quantity-button-text">-</span>
        </button>
      </div>

      {/* Add to Cart Button */}
      <button
        className={`add-to-cart-button ${isDisabled ? "disabled" : ""}`}
        onClick={handleAddToCart}
        disabled={isDisabled}
      >
        <FontAwesomeIcon icon={faBagShopping} className="cart-icon" />
        <span className="add-to-cart-text">
          {langue == "F" ? "Ajout au Panier" : "اضف الى السلة"}
        </span>
      </button>
    </div>
  );
};

export default React.memo(ListeArticles);
